import KmxCheckCircleFilled from '@kmx/mui-icons/KmxCheckCircleFilled';
import KmxCheckCircleStroked from '@kmx/mui-icons/KmxCheckCircleStroked';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { memo, type MouseEventHandler, useCallback } from 'react';

import type { CompareConfig } from '@/types/CompareConfig';

type CompareButtonProps = Omit<IconButtonProps, 'className' | 'onClick'> & {
  isSelected: CompareConfig['isSelected'];
  onClick: CompareConfig['onClick'];
};

function CompareButton({
  isSelected,
  onClick,
  size = 'small',
  ...iconButtonProps
}: CompareButtonProps) {
  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    onClick(!isSelected);
  }, [isSelected, onClick]);

  return (
    <IconButton
      aria-label={isSelected ? 'Remove from Compare' : 'Add to Compare'}
      className="kmx-car-tile__compare-button"
      data-selected={isSelected}
      onClick={handleClick}
      size={size}
      title={isSelected ? 'Remove from Compare' : 'Add to Compare'}
      {...iconButtonProps}
    >
      {isSelected ? (
        <KmxCheckCircleFilled color="info" />
      ) : (
        <KmxCheckCircleStroked />
      )}
    </IconButton>
  );
}

export default memo(CompareButton);
